/**
 * Created by Vladislav on 25.09.2024.
 */

Placements.ENTRIES["repeatedQuests"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1,
    filter: function () {
        return cleverapps.environment.isMainScene()
            && Merge2.current && Merge2.current.quests && Merge2.current.quests.isRepeatedQuestsAvailable();
    },

    action: function () {
        Merge2.current.quests.runRepeatedQuests();
    },

    interval: cleverapps.config.debugMode ? "10 seconds" : "1 hour"
};

Placements.ENTRIES["runSpecialEnergyOffer"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        return cleverapps.environment.isMainScene()
            && cleverapps.specialEnergyOffer.showPlacement;
    },

    action: function () {
        cleverapps.specialEnergyOffer.showPlacement = false;

        cleverapps.specialEnergyOffer.displayWindow();
    }
};

Placements.ENTRIES["runCounterStages"] = {
    type: Placements.FREE_FOCUS,
    priority: 1,
    action: function () {
        if (Merge2.current && Merge2.current.showUpFinished && !Merge2.current.counter.isActive()) {
            // do not run counter events if another free focus event wants to occur
            Merge2.current.counter.setTimeout(() => {}, 50);
        }
    }
};

Placements.ENTRIES["interstitialInactive"] = {
    type: Placements.FREE_FOCUS,
    priority: 0,
    filter: function () {
        return InterstitialHelper.checkLastFocus()
            && cleverapps.adsLimits.state(AdsLimits.TYPES.INTERSTITIAL) === AdsLimits.STATE_READY;
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "showInterstitialPlacement",
            action: function (f) {
                cleverapps.rewardedAdsManager.showInterstitial({
                    limit: AdsLimits.TYPES.INTERSTITIAL,
                    placement: AdsLimits.TYPES.INTERSTITIAL_INACTIVE
                }, f);
            }
        });
    },

    delayFromStart: "3 minutes"
};

InterstitialHelper = {
    checkLastFocus: function () {
        const focus = cleverapps.focusManager.lastFocus;
        if (!focus) {
            return false;
        }

        return focus.startsWith("missionCompleted")
            || (InterstitialHelper.ALLOWED_FOCUSES[cleverapps.config.subtype] || InterstitialHelper.ALLOWED_FOCUSES[cleverapps.config.type] || []).indexOf(focus) !== -1;
    },

    ALLOWED_FOCUSES: {
        merge2: []
    }
};